'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const CollapsibleSummaryTextOpen = renderWithRef('CollapsibleSummaryTextOpen', null, (o, s)=>jsx(RenderComp, {
        root: "span",
        forwardedRef: s,
        classNames: [
            'swan-collapsible-summary-text-open'
        ],
        props: o,
        children: o.children
    }));

export { CollapsibleSummaryTextOpen };
